export interface SubjectPropertyAddress {
    zipCode: string;
    country: string;
    addressLineTwo: string | null;
    city: string;
    county: string;
    streetaddress: string;
    state: string;
}

export interface AmazonAddress {
    zipCode: string;
    poBoxNumber: string;
    state: string;
    city: string;
}

export interface CoverPageData {
    subjectPropertyOwner: string;
    contactInformation: string;
    presenter: string;
    subjectPropertyNumber: string;
    hearingDate: string;
    subjectPropertyAddress: SubjectPropertyAddress;
    appealTo: string;
    hearingTime: string;
    amazonAddress: AmazonAddress;
}

export interface FieldConfig {
    label: string;
    field: string;
    type?: string;
    placeholder?: string;
    nested?: {
        parent: "subjectPropertyAddress" | "amazonAddress";
        field: string;
    };
    layout?: "full" | "row";
    width?: string;
}

export interface EditCoverPageProps {
    open: boolean;
    onClose: () => void;
    immutableInitialData: any;
}

export interface AppealData {
    appealDetails: {
        appealApproachCalculationData: {
            exportAppealsPackage?: {
                coverPage?: CoverPageData;
            };
        };
    };
    appealArtifactId: string;
}

export interface DisplayConfig {
    id: string;
    type: "header" | "single" | "row";
    title?: string;
    label?: string;
    field?: string;
    items?: DisplayConfigItem[];
}

export interface DisplayConfigItem {
    label: string;
    type?: "address" | "text";
    addressType?: "subjectPropertyAddress" | "amazonAddress";
    fields?: string[];
    field?: string;
}

export interface CoverPageProps {
    data: AppealData;
}

export const DEFAULT_COVER_PAGE: CoverPageData = {
    subjectPropertyOwner: "",
    contactInformation: "",
    presenter: "",
    subjectPropertyNumber: "",
    hearingDate: "",
    hearingTime: "",
    appealTo: "",
    subjectPropertyAddress: {
        zipCode: "",
        country: "",
        addressLineTwo: null,
        city: "",
        county: "",
        streetaddress: "",
        state: "",
    },
    amazonAddress: {
        zipCode: "",
        poBoxNumber: "",
        state: "",
        city: "",
    },
};
